module.exports = __webpack_public_path__ + "img/ikco.0b09713.webp";